exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".room-stat .room-status-column[data-v-2e07ae91]{line-height:46px}.room-stat .room-status-column[data-v-2e07ae91]:hover{cursor:pointer}.room-stat .room-stock-column[data-v-2e07ae91]:hover{cursor:pointer}.room-stat .room-stat-button[data-v-2e07ae91]{margin-top:8px}\n", ""]);

// exports
